import React from 'react'
import { InfiniteHits } from 'react-instantsearch-hooks-web'
import { buttonClassName } from '../ui/button/utils'
import { FirmSearchLists } from './firm/FirmSearchLists'

type ResultInfiniteListProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resultComponent: React.FC<any>
  type: 'firm' | 'offer'
}

const ResultInfiniteList: React.FC<ResultInfiniteListProps> = ({
  resultComponent,
  type,
}) => {
  if (type === 'offer') {
    return (
      <InfiniteHits
        translations={{
          showPreviousButtonText: 'Charger les résultats précédents',
          showMoreButtonText: 'Charger plus de résultats',
        }}
        classNames={{
          root: 'flex flex-col gap-8',
          list: 'flex flex-col gap-8',
          loadMore: `${buttonClassName({
            color: 'primary',
            invert: false,
            disabled: false,
          })} mx-auto font-semibold`,
          loadPrevious: buttonClassName({
            color: 'primary',
            invert: false,
            disabled: false,
          }),
          disabledLoadPrevious: 'hidden',
          disabledLoadMore: 'hidden',
        }}
        hitComponent={resultComponent}
      />
    )
  }

  return <FirmSearchLists />
}

export default ResultInfiniteList
